import { readSettingList } from '@/api/point/read';
import { ResReadPointStakeListType } from '@/types';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import Header from '@/component/Header';
import { Tables } from '@/component/pools/table/Tables';
import { pointSettingListColumns } from '@/component/point/table/ColumnData';
import { pointStatusFilter } from '@/lib/filter/stakingPoolState';
import { GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';

export default function PointStakingList() {
  const [list, setList] = useState<ResReadPointStakeListType[]>([]);

  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="스테이킹 - 리워드 세팅 및 리스트" />
        <Divider />
        <Box mb={2} />
        <Button
          variant="contained"
          onClick={() => {
            navigate('/point-setting');
          }}
        >
          신규 생성
        </Button>
        <CardContent>{list && <Tables list={list} columns={pointSettingListColumns} />}</CardContent>
      </Card>
    </Box>
  );
}
